import { gearTemplate } from './biome-sets.js';
/**
 * The quests' own gear (ADR 0047): one piece for each great deed of a chain,
 * a legendary felled or the last word of the story, drawn for it and found
 * nowhere else. Never dropped nor sold; bound when handed over like every
 * quest reward. Its stats follow the sets' rules at the quest's level, an
 * epic's worth or a legendary's, so it outdoes what the region drops without
 * outdoing the next region's rare.
 */
export const QUEST_GEAR_TEMPLATES = [
    gearTemplate({
        id: 'silver-fang-blade',
        name: 'Lame de Croc-d’Argent',
        slot: 'weapon',
        rarity: 'epic',
        level: 8,
        lootable: false,
    }),
    gearTemplate({
        id: 'bog-king-shield',
        name: 'Écu du Roi des Tourbières',
        slot: 'offhand',
        rarity: 'epic',
        level: 12,
        lootable: false,
    }),
    gearTemplate({
        id: 'ounas-re-sceptre',
        name: 'Sceptre d’Ounas-Rê',
        slot: 'weapon',
        rarity: 'epic',
        level: 15,
        lootable: false,
    }),
    gearTemplate({
        id: 'eirik-sword',
        name: 'Épée d’Eirik',
        slot: 'weapon',
        rarity: 'legendary',
        level: 20,
        lootable: false,
    }),
];
//# sourceMappingURL=quest-gear.js.map